<hr style="color: #36286B;">
<div class="grid">
<div class="col-12 md:col-12 lg:col-8 col-offset-2 standard-upload">
  <h2>Upload Document</h2>
</div>
<div class="col-12 md:col-12 lg:col-8 col-offset-2 upload-content">
  <div class="col-12 md:col-6 lg:col-6" [ngStyle]="isAccessRead?{'pointer-events': 'none'} : {'pointer-events': 'all'}">
    <p-dropdown [options]="type=='Post'? uploadTypeListPost: uploadTypeListPre" optionValue="FacilityID"
      (onChange)="CheckDropDownAndDateSelected()" [(ngModel)]="selectedDropdownValue" optionValue="Value"
      optionLabel="Text" [showClear]="false">
    </p-dropdown>
  </div>
  <div class="col-12 md:col-6 lg:col-6" [ngStyle]="isAccessRead?{'pointer-events': 'none'} : {'pointer-events': 'all'}">
    <p-calendar [showIcon]="true" inputId="icon" (onSelect)="CheckDropDownAndDateSelected()"
      [(ngModel)]="selectedUploadDate">
    </p-calendar>
  </div>
</div>
<div class="col-12 md:col-12 lg:col-8 col-offset-2">
  <span [style]="mbErrorbool?'color: #FF0000':'color:rgb(255 159 48)'"><i class="pi pi-exclamation-triangle"
      style="font-size: 1rem"></i>Total selected files must below than 5 mb. <span *ngIf="deleteFileBool">Please delete one of the following.</span></span>
  <div class="card">
    <p-fileUpload #fileUploader name="demo[]" url="./upload.php" [customUpload]="true" chooseLabel="Choose"
      [disabled]="uploadDisableBool" (uploadHandler)="onUpload($event,fileUploader,false);convertToBase64($event)"
      [auto]="true" [multiple]="true" accept=".pdf,.doc,.docx">
      <ng-template let-file pTemplate="file">
        <div class="grid">
          <div class="col-4 md:col-4 lg:col-4">{{file.name}}</div>
          <div class="col-4 md:col-4 lg:col-4 flex justify-content-end">{{file.size | filesize}}</div>
          <div class="col-4 md:col-4 lg:col-4 flex justify-content-end"><button icon="pi pi-trash" pButton type="button" label="Remove"
              (click)="removeFile(file, fileUploader)"></button></div>
        </div>
      </ng-template>
    </p-fileUpload>
    <hr>
        <div class="grid">
          <div class="col-4 md:col-4 lg:col-4"><b>Total Size:</b></div>
          <div class="col-4 md:col-4 lg:col-4 flex justify-content-end"><b>{{countTotalSize | filesize}}</b></div>
        </div>
  </div>
</div>
</div>
